import React, { useState, useRef, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje } from "../mensajes2";
import { formatMoneda, seleccionarCampo, validaMonto, formatoMonto, validaSoloNumero } from "../../util/varios";
//UI
import { Checkbox, Input, SearchInput, Select, Textarea } from "../../ui/inputs/Input";
import { DangerButton, PrimaryButton, WarningButton, SuccessButton, InfoButton } from "../../ui/buttons/Button";

import axios from "axios";
import moment from "moment";
import CatalogoObrasAsignada from "../../catalogos/catalogoObrasAsignada";
import { ModalAgregarDeduccionSolicitud } from "./modalAgregarDeduccionxSolicitud";

const headCells = [
	{
		id: "codigo",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SEC.",
		textAlign: "center",
	},
	{
		id: "descripcion",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PROG.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SPRO.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PROY.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ACT.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "PART.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "GEN.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ESP.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "SUB.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "ORD.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "CONCEPTO",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "DISPONIBLE DE OBRA Bs.",
		textAlign: "center",
	},
	{
		id: "opciones",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "MONTO VALUACION",
		textAlign: "center",
	},
];
const secondHeadCells = [
	{
		id: "codigo",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Código",
		textAlign: "center",
	},
	{
		id: "descripcion",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Descripción",
		textAlign: "center",
	},
	{
		id: "alicuota",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Alicuota",
		textAlign: "center",
	},
	{
		id: "total",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "Total Retenido",
		textAlign: "center",
	},
	{
		id: "total",
		backgroundColor: "rgba(5, 81, 130, 1)",
		color: "#ffffff",
		label: "OPCIONES",
		textAlign: "center",
	},
];

const SecondTable = (props) => {
	const [tableData, setTableData] = useState([]);
	const [operacionRete, setOperacionRete] = useState(0);
	const [retencion, setRetencion] = useState();
	const [itemSelect, setItemSelect] = useState(-1);
	const [mostrar5, setMostrar5] = useState();
	const [filterFn, setFilterFn] = useState({
		fn: (items) => {
			return items;
		},
	});
	const { TblContainer, TblHead, recordsAfterPagingAndSorting } =
		useTable(tableData, secondHeadCells, filterFn);

	const gestionarRetenciones = (ope, id, index, permiso) => (event) => {
		event.preventDefault();
		if (props.idobra === ""){
			return;
		}
		setOperacionRete(ope);
		if (ope !== 1) {
			if (id === 0){
				return;
			}
			setItemSelect(index);
			setRetencion(tableData[index]);
			//setDeshabilitado(true);	
		}
		
		//setIdObra(id);
		//setActivate(true);
		//SelectObra(id, index);
		
		//SelectObra(id, index);
		setMostrar5(true);
		
	};

	useEffect(() => {
		setTableData(props.tabla)	
	}, [props.tabla]);

	const handleAceptarDatos = (datos) => {
		setMostrar5(false);

		console.log(datos);

		let data;
		if (operacionRete === 1) {
			//for (let i = 0; i < datos.length; i++) {
			/*setTableData([...tableData, 
				{iddetalle: datos[0].iddetalle,
				idtipodeduccion: datos[0].idtipodeduccion,
				descripcion: datos[0].descripcion,
				alicuota: datos[0].alicuota,
				retenido: datos[0].retenido,
				tiporetencion: datos[0].tiporetencion,}])*/
			data = [...tableData, 
				{iddetalle: datos[0].iddetalle,
				idtipodeduccion: datos[0].idtipodeduccion,
				descripcion: datos[0].descripcion,
				alicuota: datos[0].alicuota,
				retenido: datos[0].retenido,
				tiporetencion: datos[0].tiporetencion,}];
			/*data.push({
				iddetalle: datos[0].iddetalle,
				idtipodeduccion: datos[0].idtipodeduccion,
				descripcion: datos[0].descripcion,
				alicuota: datos[0].alicuota,
				retenido: datos[0].retenido,
				tiporetencion: datos[0].tiporetencion,
			});*/

			//}
		} else if (operacionRete === 2) {
			data = [...tableData];
			const data1 = data.find( 
				a => a.idtipodeduccion === datos[0].idtipodeduccion
			)
			/*data[itemSelect].iddetalle = datos[0].iddetalle;
			data[itemSelect].idtipodeduccion = datos[0].idtipodeduccion;
			data[itemSelect].descripcion = datos[0].descripcion;
			data[itemSelect].alicuota = datos[0].alicuota;
			data[itemSelect].retenido = datos[0].retenido;
			data[itemSelect].tiporetencion = datos[0].tiporetencion;*/
			data1.iddetalle = datos[0].iddetalle;
			data1.idtipodeduccion = datos[0].idtipodeduccion;
			data1.descripcion = datos[0].descripcion;
			data1.alicuota = datos[0].alicuota;
			data1.retenido = datos[0].retenido;
			data1.tiporetencion = datos[0].tiporetencion;
			//setTableData(data);
		} else {
			//setTableData(tableData.filter((it) => it.idtipodeduccion !== retencion.idtipodeduccion))
			data = data.filter((it) => it.idtipodeduccion !== retencion.idtipodeduccion)
		}
		/*var totRet = 0.00;
		for (let i = 0; i < data.length; i++) {
			totRet = parseFloat(totRet) + parseFloat(data[i].totalrete);
		}
		totRet = Math.round(parseFloat(totRet) * Math.pow(10, 4)) / Math.pow(10, 4);
		setTotalRete(totRet);
		txtTotalRetenido.current.value = formatMoneda(totRet.toString().replace(',', '').replace('.', ','), ',', '.', 2);*/
		setTableData(data);
		//setRecords(data);
		props.data(data);
	}

	const cerrarModalActualizar = () => {
        setMostrar5(false);
    }

	return <div className="col-12 m-0 p-0 d-flex">
		<div className="col-11 m-0 p-0">
			<TblContainer>
				<TblHead />
				<tbody>
					{tableData &&
						recordsAfterPagingAndSorting().map((item, index) => (
							<tr 
								key={item.index}
								style={{ padding: "0" }}
							>
								<td
									className="align-baseline"
									style={{
										textAlign: "center",
										width: "80px",
									}}
								>
									{item.idtipodeduccion}
								</td>
								<td
									className="align-baseline"
									style={{
										textAlign: "center",
										width: "200px",
									}}
								>
									{item.descripcion}
								</td>
								<td
									className="align-baseline"
									style={{
										textAlign: "right",
										width: "100px",
									}}
								>
									{formatMoneda(parseFloat(item.alicuota).toString().replace(',', '').replace('.', ','), ',', '.', 2)}
								</td>
								<td
									className="align-baseline text-center"
									style={{ width: '150px' }}
								>
									{formatMoneda(parseFloat(item.retenido).toString().replace(',', '').replace('.', ','), ',', '.', 2)}
								</td>
								<td
                                        className="align-baseline text-center"
                                        style={{ width: '150px' }}


                                >
									<button
										onClick={gestionarRetenciones(2, item.idtipodeduccion, index)}
										title="Editar Retención"
										className="btn btn-sm btn-warning rounded-pill"
										disabled={props.operacion === 1 ? false : true}
										
									>
										<i className="fa fa-edit"></i>
									</button>
									<a> &nbsp; </a>
									<button
										onClick={gestionarRetenciones(3, item.idtipodeduccion, index)}
										title="Eliminar Retención"
										className="btn btn-sm btn-danger rounded-pill"
										disabled={props.operacion === 1 ? false : true}
									>
										<i className="fa fa-trash-alt"></i>
									</button>
								</td>
							</tr>
						))}
				</tbody>
			</TblContainer>
		</div>
		<div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
			<div className="col-auto m-0 p-0">
				<PrimaryButton icon="fa-plus m-0" disabled={props.operacion === 1 ? false : true} onClick={gestionarRetenciones(1, 0, 0)} />
			</div>
			{/*<div className="col-auto m-0 p-0">
				<WarningButton icon="fa-edit m-0" onClick={gestionarRetenciones(2, tem.idtipodeduccion, index)} />
			</div>
			<div className="col-auto m-0 p-0">
				<DangerButton icon="fa-trash-alt m-0" onClick={gestionarRetenciones(3, tem.idtipodeduccion, index)} />
			</div>*/}
		</div>
		<ModalAgregarDeduccionSolicitud
			show={mostrar5}
			operacion={operacionRete}
			onDatos={handleAceptarDatos}
			onHideCancela={cerrarModalActualizar}
			retencionsel={tableData[itemSelect]}
			retenciones={tableData}
			baseimponible={props.baseimponible}
			baseimpocontrato={props.baseimpocontrato}
			iva={props.iva}

		/>
	</div>
}


export default function SolicitudPagos(props) {
	const btnAcepta = useRef();
	const btnCancela = useRef();
	const btnImprimir = useRef();
	var op = require('../../modulos/datos')
	let token = localStorage.getItem('jwtToken');
	const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
	const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
	const [mostrar, setMostrar] = useState();
	//const [operacionRete, setOperacionRete] = useState(0);
	const [activate, setActivate] = useState(false);
	const [mensaje, setMensaje] = useState({
		mostrar: false,
		titulo: "",
		texto: "",
		icono: "",
	});
	const [records, setRecords] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [filterFn, setFilterFn] = useState({
		fn: (items) => {
			return items;
		},
	});
	const [fechaSoli, setFechaSoli] = useState();
	const [anticipo, setAnticipo] = useState(0.00);
	const [amortizado, setAmortizado] = useState(false);
	const [visibleNV, setVisibleNV] = useState("hidden");
	const [montosiniva, setMontoSinIva] = useState(0.00);
	const [montoIva, setMontoIva] = useState(0.00);
	const [baseImpoContrato, setBaseImpoContrato] = useState(0.00);
	const [montodispsiniva, setMontoDispSinIva] = useState(0.00);
	const [montodisponible, setMontoDisponible] = useState(0.00);
	const txtIdSolicitud = useRef([]);
	const txtMontoValuacion = useRef([]);
	const txtIdObraAsi = useRef();
	const txtDescripcionObra = useRef();
	const txtRazonSocial = useRef();
	const txtRif = useRef();
	const txtFecha = useRef();
	const txtObservacion = useRef();
	const cmbTipoSoli = useRef();
	const txtNroValuacion = useRef();
	const txtNumContrato = useRef();
	const lblMontodisponible = useRef();
	const lblMontoTotalObra = useRef();
	const lblTotalAnticipo = useRef();
	const checkIncluirPago = useRef(false);
	const lblAmortizacionAntic = useRef();
	const lblporamortizar = useRef();
	const txtMontoTotal = useRef();
	const lblTotalRetenido = useRef();
	const lblMontoIva = useRef();
	const lblMontoValuacion = useRef();

	const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
		useTable(records, headCells, filterFn);

	const salir = () => {
		//setRecords([]);
		//setTableData([]);
		blanquear();
		props.onHideCancela();
	};

	const aceptar = () => {
		var sigue = true;
		if (txtFecha.current.value === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La fecha de la solicitud no es valida.', icono: 'informacion' });
			sigue = false;
			txtFecha.current.focus();
		} else if (txtMontoTotal.current.value.trim() === '0,00') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Solicitud de Pago debe ser por un monto mayor a 0,00.', icono: 'informacion' });
			sigue = false;
			txtMontoValuacion.current[0].focus();
		} 
		if (sigue) {
			/*let data = [...records];
			for (let i = 0; i < data.length; i++) {
				data[i].montovaluacion = data[i].montovaluacion.replace(/\./g, "").replace(",", ".");
			}*/
			let body = {
				//operacion:props.operacion,
				idsolicitud: txtIdSolicitud.current.value,
				idobraasi: txtIdObraAsi.current.value,
				tipo: parseInt(cmbTipoSoli.current.value),
				numvaluacion: txtNroValuacion.current.value.trim() === "" ? null : txtNroValuacion.current.value.trim(),
				fecha: txtFecha.current.value,
				idefis: idefiscal,
				observacion: txtObservacion.current.value.trim().toUpperCase(),
				descripcion: txtDescripcionObra.current.value.trim().toUpperCase(),
				valuac: lblMontoValuacion.current.value.replace(/\./g, "").replace(",", "."),
				anticipo: anticipo,
				totsiniva: parseFloat(montosiniva),
				montoiva: parseFloat(montoIva),
				montopago: txtMontoTotal.current.value.replace(/\./g, "").replace(",", "."),
				amortianti: lblAmortizacionAntic.current.value.replace(/\./g, "").replace(",", "."),
				bporamortizar: checkIncluirPago.current.checked,
				mporamortizar: lblporamortizar.current.value.replace(/\./g, "").replace(",", "."),
				cuentas: JSON.stringify(records),
				deducciones: JSON.stringify(tableData),
				
			};
			//alert(JSON.stringify(body))
			actualizarSolicitudPago(body);
		}

	};

	const actualizarSolicitudPago = (body) => {
		setActivate(true);
		let endpoint = `${op.conexion}/api/ingenieria/actualizarsolicitudpago/${props.operacion}`;
		axios
			.post(endpoint, body, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				setActivate(false);
				if (response.status == 200) {
					if (response.data) {
						
						//setDesde(1);
						blanquear();
						setMensaje({
							mostrar: true,
							titulo: "Exito.",
							texto: "El registro " + response.data.rows[0].valret + " fué actualizado.",
							icono: "informacion",
						});
						/*if (props.operacion === 1) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido asignada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 2) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido modificada de manera satisfactoria.",
								icono: "informacion",
							});
						} else if (props.operacion === 3) {
							setMensaje({
								mostrar: true,
								titulo: "Exito.",
								texto:
									"La Obra ha sido ha sido Eliminada de manera satisfactoria.",
								icono: "informacion",
							});
						}*/

					}
				}

			})
			.catch(function (error) {
				setMensaje({
					mostrar: true,
					titulo: "ERROR",
					texto: error.response.data.message,
					icono: "error",
				});
				setActivate(false);
			});
	};

	const cerrarModal = () => {
		setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
		props.onHideCancela();
	};

	const handleInputMontoChange = (index, idcuenta) => (event) => {
		//event.preventDefault();
		validaMonto(event);
		if (event.target.value === "" || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.0) {
			event.target.value = "0,00";
		}
		if (event.which >= 37 && event.which <= 40) {
			event.preventDefault();
		}
		if (event.which === 13 || typeof (event.which) === 'undefined') {
			/* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
				event.target.value = '0,00'
			} */
			event.target.value = (formatoMonto(event.target.value));
			let char1 = event.target.value.substring(0, 1);
			let char2 = event.target.value.substring(1, 2);
			if (char1 === '0' && char2 !== ',') {
				event.target.value = event.target.value.substring(1, event.target.value.legth);
			}
			const data = [...records];
			const data1 = data.find( 
				a => a.idcuenta === idcuenta
			)
			let totMonto = parseFloat(0.00);
			let totPag = parseFloat(0.00);
			let totPagUC = parseFloat(0.00);

			//data[index].montodeclarado = event.target.value;
			//data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');



			//let dispo = props.operacion === 1 ? parseFloat(data[index].dispon) : parseFloat(data[index].montoiva)
			let dispo = props.operacion === 1 ? parseFloat(records[index].dispon) : parseFloat(records[index].montoiva)
			let montoobra = parseFloat(formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.'));
			//let factorCambio = parseFloat(props.factorCambio);
			if (montoobra > dispo) {
				setMensaje({
					mostrar: true,
					titulo: "Advertencia",
					texto:
						"El monto no debe ser mayor al disponible ",
					icono: "error",
				});
				return;
			} else {
				//data[index].montovaluacion = formatoMonto(event.target.value);
				data1.montovaluacion = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.'));
			}
			let totalObra = parseFloat(0.00);
			let totanticip = parseFloat(0.00);
			for (let i = 0; i < data.length; i++) {
				//totMonto += parseFloat(data[i].montovaluacion.replace(/\./g, '').replace(',', '.'));
				totalObra += parseFloat(data[i].montovaluacion);
				totanticip += parseFloat(data[i].montoobra);
			}
			lblMontoValuacion.current.value = formatMoneda(totalObra.toString().replace('.', ','), ',', '.', 2);
			lblTotalAnticipo.current.value = formatMoneda(totanticip.toString().replace('.', ','), ',', '.', 2);
			//txtTotalObra.current.value = formatMoneda(totMonto.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
			setRecords(data);
			event.target.value = (formatoMonto(event.target.value));
			calcular(records);
			if (event.which === 13) {
				if (index + 1 === txtMontoValuacion.current.length) {
					//txtDeclaradoRef.current[index].focus();
					btnAcepta.current.focus();
					//setColocaFocus(true);
				} else {
					txtMontoValuacion.current[index + 1].focus();
					//setColocaFocus(false);
				}
			} else {
				//setColocaFocus(false);
			}


		} else if (event.which === 46) {
			return false;
		} else if (event.which >= 48 && event.which <= 57) {
			return true;
		} else if (event.which === 8 || event.which === 0 || event.which === 44) {
			return true;
		} else return false;//alert(e.which);

	};

	const imprimirSolicitud = () => {
		var sigue = true;
		if (txtNumContrato.current.value.trim() === '') {
			setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'No se Puede Imprimir ya que se Requiere el Número de Contrato de la Obra.', icono: 'informacion' });
			sigue = false;
			txtNumContrato.current.focus();
		} 
		if (sigue) {
			let reporte = "ForSoliPagoObras";
			
			let monto = txtMontoValuacion.current.value;
			
			let sql = txtIdSolicitud.current.value;
			let valuacion = cmbTipoSoli.current.value === "0" ? "Pago de Anticipo " : "Pago de Valuación N° "+txtNroValuacion.current.value;

			window.open(
				op.reportes +
				"/ingenieria?" +
				"reporte=" +
				reporte +
				"&TIT_CRI1=" +
				valuacion +
				"&CONDICION=" +
				sql +
				"&IDEFISCAL=" +
				idefiscal,
				"Planilla",
				"fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
			);
		}
	}

	const seleccionarObra = (id, tecla) => {
		//alert(idobra)
		setActivate(true)
		let endpoint = `${op.conexion}/api/ingenieria/seleccionarobraasignadasp?id=${id}&operacion=${props.operacion}&idefiscal=${idefiscal}`;

		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					'Content-Type': 'application/json'

				},
			})
			.then((response) => {
				if (response.status == 200) {
					if (response.data.length > 0) {
						if (response.data[0].numcontrato === null || response.data[0].numcontrato.trim() === "") {
							setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Obra no Posee Contrato.', icono: 'informacion' });
							setActivate(false);
							return;
						}
						const data = [...response.data];
						//const data1 = [...data];
						var totDispo = parseFloat(0.00);
						for (let i = 0; i < data.length; i++) {
							data[i].montovaluacion = props.operacion === 1 ? parseFloat(data[i].dispon) : parseFloat(data[i].montoiva);
							//totDispo += parseFloat(data[index].montoinicial) + parseFloat(data[index].aumentado) - parseFloat(data[index].disminuido) - parseFloat(data[index].comprometido);
						}
						
						setRecords(data);
						if (data[0].tipoobra === 2) {
							txtDescripcionObra.current.value = data[0].descripcion.trim();
						} else {
							txtDescripcionObra.current.value = data[0].descripcionobra === null ? "" : data[0].descripcionobra.trim();
						}
						txtRazonSocial.current.value = data[0].razonsocial;
						txtRif.current.value = data[0].rif;
						txtNumContrato.current.value = data[0].numcontrato;
						//setRecords(response.data);

						let nAnticipo = data[0].porantic === null ? parseFloat(0.00) : parseFloat(data[0].porantic);
						setAnticipo(nAnticipo);
						if (props.operacion === 1) {
							txtFecha.current.value = moment.utc(fechasistema).format("YYYY-MM-DD");
							txtObservacion.current.value = data[0].nombreobra === null ? "" : data[0].nombreobra.trim();
							if (nAnticipo > 0.00) {
								//cmbTipoSoli.current.value = 1;
								seleccionarAnticipos(response.data[0].idobraasignada, data, nAnticipo);

							} else {
								cmbTipoSoli.current.value = 1;
								seleccionarUltimaValuacion(txtIdObraAsi.current.value, data);
								/*calcularTotales(data);
								calcularTotalesRet();
								calcular(data);*/
							}
						} else {
							//txtFecha.current.value = moment.utc(fechaSoli).format('DD-MM-YYYY');
							if (data[0].cierre === 1) {
								checkIncluirPago.checked = true;
							} else {
								checkIncluirPago.checked = false;
							}
							seleccionarDetalleDeduccion(txtIdSolicitud.current.value, data, nAnticipo)
							//calcularTotales(data);
							/*calcularTotalesRet();
							calcular(data);*/
						}
						if (tecla === 13) {
							cmbTipoSoli.current.focus();
						}
					} else {
						setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Obra no Existe.', icono: 'informacion' });
						txtIdObraAsi.current.value = "";
						if (tecla === 13) {
							txtIdObraAsi.current.focus();
						}
					}
				}
				setActivate(false);
			})
			.catch((error) => {
				setActivate(false),
					setMensaje({
						mostrar: true,
						titulo: "ERROR",
						texto: error.response.data.message,
						icono: "error",
					});
				console.log(error)
			});
	};

	const validarObra = (event) => {
		event.preventDefault();

		validaSoloNumero(event);
		if (event.which === 13 || typeof event.which === "undefined") {
			if (event.target.value !== "") {
				seleccionarObra(event.target.value, event.which);
			} else {
				txtIdObraAsi.current.value = "";
				txtDescripcionObra.current.value = "";
				//txtMonto.current.value = "";
			}
		}
	};

	const calcularTotales = (data, tabla, nanticipo) => {
		let totMon = parseFloat(0.00), val = parseFloat(0.00), val1 = parseFloat(0.00), val2 = parseFloat(0.00), tottalobra = parseFloat(0.00), tottantic = parseFloat(0.00);
		let totalObra = parseFloat(0.00);
		let totalsiniva = parseFloat(0.00);
		let mon, totob, totant;
		for (let i = 0; i < data.length; i++) {
			mon = props.operacion === 1 ? parseFloat(data[i].dispon) : parseFloat(data[i].montoiva);
			totMon = totMon + mon;
			tottalobra = tottalobra + parseFloat(data[i].montoobra);
			tottantic = tottantic + parseFloat(data[i].montoobra);
			totalObra = totalObra + parseFloat(data[i].montoobra);
			if (data[i].puc.trim() !== "403180100") {
				totalsiniva = totalsiniva + parseFloat(data[i].montoobra);
			}
		}
		val = totMon;
		val1 = tottalobra;
		val2 = tottantic;
		lblMontodisponible.current.value = formatMoneda(val.toString().replace('.', ','), ',', '.', 2)
		lblMontoTotalObra.current.value = formatMoneda(val1.toString().replace('.', ','), ',', '.', 2)
		lblTotalAnticipo.current.value = formatMoneda(val2.toString().replace('.', ','), ',', '.', 2)
		setBaseImpoContrato(totalsiniva);
		//lblTotalObra.setText(valfor.formato(val.toString(), "##,###,###,##0.00",frmRegObras, txtMonto));
		calcularTotalesRet(tabla, data, nanticipo);
	}

	const calcularTotalesRet = (tabla, data, nanticipo) => {
		let totMon = parseFloat(0.00), val = parseFloat(0.00);
		for (let i = 0; i < tabla.length; i++) {
			totMon = totMon + parseFloat(tabla[i].retenido);
		}
		val = totMon;
		//txtCodigo.setText(valfor.formato(String.valueOf(totalObra), "##,###,###,##0.00",frmSolicPagObras, newEditor));
		lblTotalRetenido.current.value = formatMoneda(val.toString().replace('.', ','), ',', '.', 2);
		//lblTotalObra.setText(valfor.formato(val.toString(), "##,###,###,##0.00",frmRegObras, txtMonto));
		calcular(data, nanticipo);
	}

	const calcular = (data,nanticipo) => {
		let iva = parseFloat(0.00), disponible = parseFloat(0.00), disponiblesiniva = parseFloat(0.00);
		let amortiza = parseFloat(0.00);
		let poramortizar = parseFloat(0.00);
		let poragregar = parseFloat(0.00);
		let valuac = parseFloat(0.00);
		let totsiniva = parseFloat(0.00);
		let siniva = parseInt(0)
		for (let i = 0; i < data.length; i++) {
			if (data[i].puc.trim() === "403180100") {
				//iva = iva + parseFloat(data[i].montovaluacion.replace(/\./g, '').replace(',', '.'));
				iva = iva + parseFloat(data[i].montovaluacion);
				disponiblesiniva = disponiblesiniva + (props.operacion === 1 ? parseFloat(data[i].dispon) : parseFloat(data[i].montoiva))
			} else {
				//totsiniva = totsiniva + parseFloat(data[i].montovaluacion.replace(/\./g, '').replace(',', '.'));
				totsiniva = totsiniva + parseFloat(data[i].montovaluacion);
				disponible = disponible + (props.operacion === 1 ? parseFloat(data[i].dispon) : parseFloat(data[i].montoiva));
			}
			totsiniva = Math.round(totsiniva * Math.pow(10, 2)) / Math.pow(10, 2);
			//valuac = valuac + parseFloat(data[i].montovaluacion.replace(/\./g, '').replace(',', '.'));
			valuac = valuac + parseFloat(data[i].montovaluacion);
		}
		setMontoSinIva(totsiniva);
		setMontoIva(iva);
		setMontoDisponible(disponible);
		setMontoDispSinIva(disponiblesiniva);
		lblMontoIva.current.value = formatMoneda(iva.toString().replace('.', ','), ',', '.', 2);
		//n = valfor.formato(valuac.toString(), "##,###,###,##0.00", frmSolicPagObras, txtCodigo);
		lblMontoValuacion.current.value = formatMoneda(valuac.toString().replace('.', ','), ',', '.', 2);

		//Double val = ((anticipo / 100) * Double.parseDouble(sincomatotalobra));
		if (data[0].siniva === 1) {
			amortiza = totsiniva * nanticipo / 100;
			poramortizar = parseFloat(lblMontoTotalObra.current.value.replace(/\./g, '').replace(',', '.')) * anticipo / 100;
			poragregar = (disponible * nanticipo / 100);
		} else {
			amortiza = valuac * nanticipo / 100;
			poramortizar = parseFloat(lblMontoTotalObra.current.value.replace(/\./g, '').replace(',', '.')) * anticipo / 100;
			poragregar = ((disponible + disponiblesiniva) * nanticipo / 100);
		}


		let val = valuac - parseFloat(lblTotalRetenido.current.value.replace(/\./g, '').replace(',', '.')) - amortiza;
		let val1 = poragregar - Math.round(amortiza * Math.pow(10, 2)) / Math.pow(10, 2);
		val1 = Math.round(val1 * Math.pow(10, 2)) / Math.pow(10, 2);
		if (checkIncluirPago.current.checked === true) {
			val = (valuac - parseFloat(lblTotalRetenido.current.value.replace(/\./g, '').replace(',', '.')) - amortiza - val1);
		}
		if (cmbTipoSoli.current.value === "0") {
			lblporamortizar.current.value = "0,00";
			//n = valfor.formato(amortiza.toString(), "##,###,###,##0.00", frmSolicPagObras, txtCodigo);
			txtMontoTotal.current.value = formatMoneda(amortiza.toString().replace('.', ','), ',', '.', 2);
			lblAmortizacionAntic.current.value = "0,00";
		} else {
			//n = valfor.formato(val1.toString(), "##,###,###,##0.00", frmSolicPagObras, txtCodigo);
			lblporamortizar.current.value = formatMoneda(val1.toString().replace('.', ','), ',', '.', 2);;
			//n = valfor.formato(val.toString(), "##,###,###,##0.00", frmSolicPagObras, txtCodigo);
			txtMontoTotal.current.value = formatMoneda(val.toString().replace('.', ','), ',', '.', 2);;
			//n = valfor.formato(amortiza.toString(), "##,###,###,##0.00", frmSolicPagObras, txtCodigo);
			lblAmortizacionAntic.current.value = formatMoneda(amortiza.toString().replace('.', ','), ',', '.', 2);;
		}


		return true;

	}

	const seleccionarAnticipos = (id, data, nanticipo) => {
		let campos = "anticipoobras.*";
		let nomtab = "obraasignada";
		let nomid = "idobraasignada";
		let nomtab2 = "anticipoobras";
		let nomid3 = "idobra";

		let endpoint = `${op.conexion}/api/consulta/modeli10rows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${parseInt(id)}&nomtab2=${nomtab2}&nomid3=${nomid3}`;

		setActivate(true);
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				if (response.status === 200) {
					let nomobra = "";
					if (response.data.length > 0) {
						var nMonto = parseFloat(0.00);
						for (let i = 0; i < response.data.length; i++) {
							nMonto = nMonto + parseFloat(response.data[i].monto)
						}
						setAmortizado(true);
						if (props.operacion === 1) {
							cmbTipoSoli.current.value = 1;
							//handleCmbTipoSoli();
							setVisibleNV("visible");
							seleccionarUltimaValuacion(txtIdObraAsi.current.value, data);
							/*txtNroValuacion.setText(String.valueOf(Integer.valueOf(ultimavaluacion) + 1));
							nomobra = "PAGO DE LA VALUACIÓN N° " + txtNroValuacion.getText().trim() + " CORRESPONDIENTE A LA OBRA " + lblDescripcion.getText().trim();
							txtObservacion.setText("");
							txtObservacion.setText(nomobra.trim());
							calcularTotales();
							calcularTotalesRet();
							calcular();*/
						}
					} else {
						if (props.operacion === 1) {
							setAmortizado(false);
							cmbTipoSoli.current.value = 0;
							//handleCmbTipoSoli();
							setVisibleNV("visible");
							if (nanticipo > 0) {
								setVisibleNV("hidden");
								nomobra = "PAGO DEL " + anticipo + " % DE ANTICIPO " + " CORRESPONDIENTE A LA OBRA " + txtDescripcionObra.current.value.trim();
								txtObservacion.current.value = "";
								txtObservacion.current.value = nomobra.trim();
								lblMontoValuacion.current.value = "0,00";
								lblMontoIva.current.value = "0,00";
								
								calcularTotales(data, tableData, nanticipo);
								/*calcularTotalesRet();
								calcular(data);*/
							} else {
								setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Obra no Estipula Anticipo.', icono: 'informacion' });
								cmbTipoSoli.current.value = "1";
								cmbTipoSoli.current.focus();
							}
						}
					}
				}
				setActivate(false);

			})
			.catch(function (error) {
				setActivate(false);
				setMensaje({
					mostrar: true,
					titulo: "Error",
					texto: error.response.data.message,
					icono: "error",
				});
			});
	};

	const seleccionarUltimaValuacion = (id, data) => {

		let endpoint = `${op.conexion}/api/ingenieria/seleccionarultimavaluacion?idasignada=${id}&idefiscal=${idefiscal}`;

		setActivate(true);
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				if (response.status === 200) {
					if (response.data.length > 0) {
						if (response.data[0].ultimavaluacion === null){
							txtNroValuacion.current.value = "1";	
						} else{
							txtNroValuacion.current.value = parseInt(response.data[0].ultimavaluacion) + 1;
						}
						
					} else {
						txtNroValuacion.current.value = "1";
					}
					let nomobra = "PAGO DE LA VALUACIÓN N° " + txtNroValuacion.current.value + " CORRESPONDIENTE A LA OBRA " + txtDescripcionObra.current.value.trim();
					txtObservacion.current.value = "";
					txtObservacion.current.value = nomobra.trim();
					calcularTotales(data, tableData, anticipo);
					/*calcularTotalesRet();
					calcular(data);*/
				}
				setActivate(false);

			})
			.catch(function (error) {
				setActivate(false);
				setMensaje({
					mostrar: true,
					titulo: "Error",
					texto: error.response.data.message,
					icono: "error",
				});
			});
	};

	const seleccionarDetalleDeduccion = (id, data, nanticipo) => {

		let campos = "*"
        let nomtab = "deduccionxvaluacion";
        let nomid = "idsolicitudpagoobras";
        let condic = "idefiscal = " + idefiscal;
        let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`

		setActivate(true);
		axios
			.get(endpoint, {
				headers: {
					"x-access-token": `${token}`,
					"Content-Type": "application/json",
				},
			})
			.then(function (response) {
				if (response.status === 200) {
					//if (response.data.length > 0) {
						setTableData(response.data);
						calcularTotales(data, response.data, nanticipo);	
					//}
				}
				setActivate(false);

			})
			.catch(function (error) {
				setActivate(false);
				setMensaje({
					mostrar: true,
					titulo: "Error",
					texto: error.response.data.message,
					icono: "error",
				});
			});
	};

	const handleCmbTipoSoli = (event) => {
		event.preventDefault();
		let nomobra = "";

		if (cmbTipoSoli.current.value === "0" && txtIdObraAsi.current.value !== "") {
			if (anticipo > 0) {
				if (amortizado) {
					setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Obra ya tiene Anticipo.', icono: 'informacion' });
					cmbTipoSoli.current.value = "1";
					cmbTipoSoli.current.focus();
				} else {
					setVisibleNV("hidden");
					nomobra = "PAGO DEL " + anticipo + " % DE ANTICIPO " + " CORRESPONDIENTE A LA OBRA " + txtDescripcionObra.current.value.trim();
					txtObservacion.current.value = "";
					txtObservacion.current.value = nomobra.trim();
					lblMontoValuacion.current.value = "0,00";
					lblMontoIva.current.value = "0,00";

				}
				calcular(records);
			} else {
				setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Obra no Estipula Anticipo.', icono: 'informacion' });
				cmbTipoSoli.current.value = "1";
				cmbTipoSoli.current.focus();
			}

		} else if (txtIdObraAsi.current.value !== "") {
			setVisibleNV("visible");

			seleccionarUltimaValuacion(txtIdObraAsi.current.value, records);
			/*txtNroValuacion.setText(String.valueOf(Integer.valueOf(ultimavaluacion) + 1));
			nomobra = "PAGO DE LA VALUACIÓN N° " + txtNroValuacion.getText().trim() + " CORRESPONDIENTE A LA OBRA " + lblDescripcion.getText().trim();
			txtObservacion.setText("");
			txtObservacion.setText(nomobra.trim());*/
			/*group1.setEnabled(true);
			table1.setEnabled(true);
			toolBar1.setEnabled(true);
			calcular();*/
		}
	};

	const handleCheckIncluirPago = (event) => {
		calcular(records);
	};

	const handleTablaDeducciones = (tabla) => {
		const data = [...tabla]
        setTableData(data);
		calcularTotalesRet(data, records, anticipo)
		//calcular(records);
    };

	const blanquear = () => {
		txtDescripcionObra.current.value = "";
		setRecords([]);
		setTableData([]);
		txtRazonSocial.current.value = "";
		txtRif.current.value = "";
		txtObservacion.current.value = "";
		lblAmortizacionAntic.current.value = "0,00";
		lblporamortizar.current.value = "0,00";
		txtMontoTotal.current.value = "0,00";
		lblTotalRetenido.current.value = "0,00";
		lblMontoIva.current.value = "0,00";
		lblMontoValuacion.current.value = "0,00";
		lblMontoTotalObra.current.value = "0,00";
		lblMontodisponible.current.value = "0,00";
		lblTotalAnticipo.current.value = "0,00";
	}

	const handleCancelaObra = () => {
		setMostrar(false);
	};

	const handleAceptarObra = (
		idobraasignada,
		descripcionobra,
		razonsocial,
		idobra,
		idproveedor
	) => {
		txtIdObraAsi.current.value = idobraasignada;

		seleccionarObra(idobraasignada, 13);
		setMostrar(false);
	};

	return (
		<Modal
			size="xl"
			{...props}
			centered backdrop="static"
			keyboard={false}
			onShow={() => {
				if (props.operacion === 1) {
					txtIdSolicitud.current.value = "0";
				} else {
					txtIdSolicitud.current.value = props.obra.idsolicitudpagoobras;
					txtIdObraAsi.current.value = props.obra.idobraasignada;
					txtFecha.current.value = moment.utc(props.obra.fecha).format("YYYY-MM-DD");
					cmbTipoSoli.current.value = props.obra.tipo;
					txtObservacion.current.value = props.obra.observaciones !== null ? props.obra.observaciones.trim() : "";
					if (props.obra.tipo === 0) {
						setVisibleNV("hidden");
					} else {
						setVisibleNV("visible");
						txtNroValuacion.current.value = props.obra.numvaluacion !== null ? props.obra.numvaluacion.trim() : "";

					}
					let nmonValuacion = parseFloat(props.obra.monto);
					lblMontoValuacion.current.value = formatMoneda(nmonValuacion.toString().replace('.', ','), ',', '.', 2);
					seleccionarObra(txtIdSolicitud.current.value, 13)
					/*txtMontoObra.current.value = formatMoneda(props.obra.monto.toString().replace('.', ','), ',', '.', 2)
					//txtDescripcionObra.current.value = props.obra.descripcionobra;
					txtDescripcionObra.current.value = props.cuentas[0].tipoobra === 2 ? props.cuentas[0].descripcion.trim() : props.cuentas[0].descripcionobra.trim();
					txtFechaApro.current.value = props.cuentas[0].fecapro === null ? moment.utc(fechasistema).format("YYYY-MM-DD") : moment.utc(props.cuentas[0].fecapro).format("YYYY-MM-DD");
					txtNumContrato.current.value = props.cuentas[0].numcontrato === null ? "" : props.cuentas[0].numcontrato;
					txtPorceFiel.current.value = props.cuentas[0].porcfiel === null ? "0,00" : formatMoneda(props.cuentas[0].porcfiel.toString().replace('.', ','), ',', '.', 2);
					txtPorceAnti.current.value = props.cuentas[0].porantic === null ? "0,00" : formatMoneda(props.cuentas[0].porantic.toString().replace('.', ','), ',', '.', 2);
					var monant = parseFloat(0.00);
					if (props.cuentas[0].porantic !== null && parseFloat(props.obra.monto) > 0 && parseFloat(props.cuentas[0].porantic) > 0) {
						monant = parseFloat(props.obra.monto) * parseFloat(props.cuentas[0].porantic) / 100;
						monant = Math.round(monant * Math.pow(10, 2)) / Math.pow(10, 2);
					}
					txtMontoAnti.current.value = formatMoneda(monant.toString().replace('.', ','), ',', '.', 2);
					var monfiel = parseFloat(0.00);
					if (props.cuentas[0].porcfiel !== null && parseFloat(props.obra.monto) > 0 && parseFloat(props.cuentas[0].porcfiel) > 0) {
						monfiel = parseFloat(props.obra.monto) * parseFloat(props.cuentas[0].porcfiel) / 100;
						monfiel = Math.round(monfiel * Math.pow(10, 2)) / Math.pow(10, 2);
					}
					txtMontoFiel.current.value = formatMoneda(monfiel.toString().replace('.', ','), ',', '.', 2);
					if (props.cuentas[0].tipoobra === 1) {
						radioObra.current.checked = true;
						radioServicio.current.checked = false;
					} else {
						radioObra.current.checked = false;
						radioServicio.current.checked = true;
					}
					if (props.cuentas[0].condicion === "0") {
						radioNo.current.checked = true;
						radioSi.current.checked = false;
					} else {
						radioNo.current.checked = false;
						radioSi.current.checked = true;
					}
					txtPlazoIni.current.value = props.cuentas[0].plazoini === null ? "" : props.cuentas[0].plazoini;
					txtPlazoEjec.current.value = props.cuentas[0].plazoejec === null ? "" : props.cuentas[0].plazoejec;
					txtGarantia.current.value = props.cuentas[0].lapsogar === null ? "" : props.cuentas[0].lapsogar;
					txtManera.current.value = props.cuentas[0].manera === null ? "" : props.cuentas[0].manera;
					setRecords(props.cuentas);
					seleccionarProveedor(props.obra.idproveedor);*/
				}
			}}>

			<Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
				<h3 className="fw-bold m-0">Solicitud de Pago de Obras</h3>
				<a type="button" className="fw-bold text-light fs-6" onClick={salir}>
					Salir <i className="fa fa-times ms-2"></i>
				</a>
			</Modal.Header>
			<Modal.Body className="col-12 m-0 p-2 d-flex flex-wrap d-flex">
				<div className="col-2 m-0 p-0">
					<Input label="Código:" readOnly ref={txtIdSolicitud} />
				</div>
				<div className="col-2 m-0 p-0 pl-2">
					<SearchInput label="Código Obra:"
						readOnly={props.operacion === 1 ? false : true}
						disabledButton={props.operacion === 1 ? false : true}
						ref={txtIdObraAsi}
						onKeyUp={validarObra}
						onBlur={validarObra}
						onChange={() => {
							blanquear();
						}}
						onClickButton={() => {
							setMostrar(true);
						}}
					/>
				</div>
				<div className="col-2 m-0 p-0 pl-2">
					<Select label="Tipo Solicitud:" readOnly={props.operacion === 1 ? false : true} ref={cmbTipoSoli} onChange={handleCmbTipoSoli}>
						<option key="0" value="0">ANTICIPO</option>
						<option key="1" value="1">VALUACION</option>
					</Select>
				</div>
				<div className="col-2 m-0 p-0 pl-2" style={{ visibility: visibleNV }}>
					<Input label="Nro." readOnly ref={txtNroValuacion} />
				</div>
				<div className="col-2 m-0 p-0 pl-2">
					<Input label="Nº de Contrato:" readOnly ref={txtNumContrato} />
				</div>
				<div className="col-2 m-0 p-0 pl-2">
					<Input label="Fecha:" type="date" readOnly={props.operacion === 1 ? false : true} ref={txtFecha} max={moment.utc(fechasistema).format("YYYY-MM-DD")} />
				</div>
				<div className="col-9 m-0 mb-2 p-0 pl-2">
					<Textarea readOnly label='Descripción:' style={{ height: 70 }} ref={txtDescripcionObra} />
				</div>
				<fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
					<legend className="float-none w-auto m-0">
						Datos del Contratista
					</legend>
					<div className="col-9 m-0 p-0">
						<Input readOnly ref={txtRazonSocial} />
					</div>
					<div className="col-3 m-0 p-0 pl-2">
						<Input readOnly ref={txtRif} />
					</div>
				</fieldset>
				<div className="col-12 m-0 p-0">
					<TblContainer>
						<TblHead />
						<tbody>
							{records &&
								recordsAfterPagingAndSorting().map((item, index) => (
									<tr key={index}>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.categoria.substring(0, 2)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.categoria.substring(2, 4)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.categoria.substring(4, 6)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.categoria.substring(6, 8)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.categoria.substring(8, 10)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.puc.substring(0, 3)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.puc.substring(3, 5)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.puc.substring(5, 7)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.puc.substring(7, 9)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.auxiliar}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{item.descripcion}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "center", alignItems: "center" }}
										>
											{formatMoneda((props.operacion === 1 ? parseFloat(item.dispon) : parseFloat(item.montoiva)).toString().replace(',', '').replace('.', ','), ',', '.', 2)}
										</td>
										<td
											className="align-baseline"
											style={{ textAlign: "right", alignItems: "center" }}
										>
											<input ref={el => txtMontoValuacion.current[index] = el} type="text" readOnly={props.operacion === 1 ? false : true} autoComplete="off" name={item.proyecto} defaultValue={item.montovaluacion ? formatMoneda(parseFloat(item.montovaluacion).toString().replace(',', '').replace('.', ','), ',', '.', 2) : "0,00"} style={{ width: "140px", textAlign: "right", fontSize: "10" }} onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange(index, item.idcuenta)} onBlur={handleInputMontoChange(index, item.idcuenta)} className="form-control text-uppercase" />
										</td>
									</tr>
								))}
						</tbody>
					</TblContainer>
				</div>
				<div className="col-8 m-0 p-0">
					<SecondTable data={handleTablaDeducciones} 
						idobra={txtIdObraAsi.current ? txtIdObraAsi.current.value : ""}
						baseimponible={montosiniva}
						baseimpocontrato={baseImpoContrato}
						iva={montoIva}
						operacion={props.operacion}
						tabla={tableData}
					/>
					<div className="col-12 m-0 mt-2 p-0">
						<Textarea label='Concepto de Solicitud de Pago:' ref={txtObservacion} style={{ height: 70 }} />
					</div>
				</div>
				<div className="col-4 m-0 p-0 pl-2">
					<div className="col-12 m-0 p-0">
						<Input label='Monto de la Obra:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblMontoTotalObra} />
					</div>
					<div className="col-12 m-0 p-0">
						<Input label='Total Anticipo:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblTotalAnticipo} />
					</div>
					<div className="col-12 m-0 p-0">
						<Input label='Monto Disponible:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblMontodisponible} />
					</div>
					<br />
					<div className="col-12 m-0 p-0">
						<Input label='Monto de valuacion:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblMontoValuacion} />
					</div>
					<div className="col-12 m-0 p-0">
						<Input label='Monto IVA:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblMontoIva} />
					</div>
					<div className="col-12 m-0 p-0">
						<Input label='Total Otras Deducciones:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblTotalRetenido} />
					</div>
					<div className="col-12 m-0 p-0">
						<Input label='Amortización Anticipo:' readOnly inputClassName='text-end' placeholder='0.00' ref={lblAmortizacionAntic} />
					</div>
					<fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
						<legend className="float-none w-auto m-0">
							Total por Amortizar
						</legend>
						<div className="col-auto m-0 p-0">
							<Checkbox label="Incluir al Pago:" id="incluirPago" disabled={props.operacion === 1 ? false : true} ref={checkIncluirPago} onChange={handleCheckIncluirPago}/>
						</div>
						<div className="col m-0 p-0 pl-2">
							<Input inputClassName='text-end' readOnly placeholder='0.00' ref={lblporamortizar} />
						</div>
					</fieldset>
					<fieldset className="col-12 m-0 mb-2 p-2 d-flex border-azul rounded">
						<legend className="float-none w-auto m-0">
							Datos del Pago
						</legend>
						<div className="col m-0 p-0 pl-2">
							<Input label='Monto Total del Pago' readOnly inputClassName='text-end' placeholder='0.00' ref={txtMontoTotal} />
						</div>
					</fieldset>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<SuccessButton disabled={props.operacion !== 4 ? false : true} ref={btnAcepta} onClick={aceptar}>
					Aceptar
				</SuccessButton>
				<DangerButton ref={btnCancela} onClick={salir}>
					Cancelar
				</DangerButton>
				<InfoButton icon='fa-print'
					disabled={props.operacion === 4 ? false : true}
					onClick={imprimirSolicitud}
					ref={btnImprimir}
				>
					Imprimir
				</InfoButton>
			</Modal.Footer>
			<Dimmer active={activate} inverted>
			</Dimmer>
			<Mensaje
				mensaje={mensaje}
				onHide={() => {
					mensaje.titulo === "Exito."
						? cerrarModal()
						: setMensaje({
							mostrar: false,
							titulo: "",
							texto: "",
							icono: "",
						});
				}}
			/>
			<CatalogoObrasAsignada
				show={mostrar}
				status={1}
				onHideCancelar={handleCancelaObra}
				onHideAceptaObra={handleAceptarObra}
			/>
			
		</Modal>
	);
}
